import authHeader from './headers'

/**
 * Development URL:
 * @url - https://sso-testing-backend-jj6mw.ondigitalocean.app/
  
 * Prod URL:
 * @url - https://sso.emision.co/api/v1/
 */

const BASE_URL = 'https://sso.emision.co/api/v1/'

/**
 * Method to facilitate API requests
 * @param {URL} url Represents the URL where the API to which the requests will be made is located.
 * @param {Request} method The different types of API requests that can be made (POST, GET, PUT, DELETE, and others). By default "GET" is set.
 * @param {Headers} header The headers that will be sent with the request.
 * @param {Object} body Corresponds to the parameters to be sent to the API. These are converted into a JSON before being sent.
 * @returns Returns the API response.
 */
async function service(url, method, header, body) {
  let response = await fetch(url, {
    method: method,
    headers: header,
    body: JSON.stringify(body)
  })
  return response.json()
}

/**
 * Method to facilitate API requests
 * @param {URL} url Represents the URL where the API to which the requests will be made is located.
 * @param {Request} method The different types of API requests that can be made (POST, GET, PUT, DELETE, and others). By default "GET" is set.
 * @param {Object} body Corresponds to the parameters to be sent to the API. These are converted into a JSON before being sent.
 * @returns Returns the API response.
 */
export default async function http(url, method, body) {
  try {
    let response = await service(
      BASE_URL + url,
      method || 'GET',
      authHeader(),
      body
    )
    return response
  } catch (error) {
    console.log(error)
  }

}

